import { Flex, RootScreen, Spinner } from '@banhala/ui-kit';
import { HomeContents } from './components';
import { Suspense } from 'react';
import { HomeHeader } from './components/HomeHeader';
import { HomeScrollContext } from './context/HomeScrollContext';
import { useHomeScroll } from './context/useHomeScroll';
import { AnalyticsScreen } from 'shared/src/context';
import { useActiveHomeTab } from './hooks/useActiveHomeTab';

export const HomeScreen = () => {
  const {
    headerVisible,
    scrollY,
    onScrollY,
    scrollToTop,
    registerScrollToTop,
  } = useHomeScroll();
  const activeHomeTab = useActiveHomeTab();
  const screenName = activeHomeTab?.screen_name ?? 'TODAY';

  return (
    <RootScreen>
      <AnalyticsScreen screen={screenName} hostsModals={false}>
        <HomeScrollContext.Provider
          value={{
            headerVisible,
            scrollY,
            onScrollY,
            scrollToTop,
            registerScrollToTop,
          }}
        >
          <HomeHeader />

          <Flex flex={1}>
            <Suspense fallback={<Spinner />}>
              <HomeContents />
            </Suspense>
          </Flex>
        </HomeScrollContext.Provider>
      </AnalyticsScreen>
    </RootScreen>
  );
};
